// Tax Declarations & IT Proofs — frontend types.
// Mirrors src/api-hr/tax/models.js + routes.js response shapes exactly.

export type TaxDeclarationStatus = 'draft' | 'submitted' | 'under_review' | 'approved' | 'rejected';
export type TaxRegime = 'old' | 'new';
export type ProofDocumentStatus = 'pending' | 'submitted' | 'verified' | 'rejected';

export interface ProofDocument {
  _id: string;
  code: string;
  label: string;
  fileUrl: string;
  submittedAt: string | null;
  status: ProofDocumentStatus;
  rejectionReason: string;
}

export interface TaxDeclaration {
  _id: string;
  tenantId: string;
  companyId: string;
  personId: string;
  employeeUserId: string;
  employeeName?: string;
  employeeDepartment?: string;
  financialYear: string;
  regime: TaxRegime;
  declarations: Record<string, number>;
  totalDeclared: number;
  approvedAmount: number;
  proofDocuments: ProofDocument[];
  status: TaxDeclarationStatus;
  submittedAt: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  rejectionReason: string;
  createdAt: string;
  updatedAt: string;
}

export interface SubmitDeclarationPayload {
  financialYear: string;
  regime: TaxRegime;
  declarations: Record<string, number>;
}

export interface UploadProofPayload {
  code: string;
  label: string;
  fileUrl: string;
}

export interface ReviewDeclarationPayload {
  decision: 'approved' | 'rejected';
  notes?: string;
  approvedAmount?: number;
}

/** Standard declaration sections shown on the form (extendable without a schema change). */
export const DECLARATION_SECTIONS = [
  { code: 'section_80c', label: 'Section 80C (PPF, ELSS, Life Insurance)', max: 150000 },
  { code: 'hra_exemption', label: 'HRA Exemption (Rent Paid)' },
  { code: 'section_80d', label: 'Section 80D (Health Insurance)' },
  { code: 'nps_80ccd', label: 'NPS (80CCD)' },
  { code: 'other_deductions', label: 'Other Deductions' },
] as const;
